import React from 'react';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { useSelector } from 'react-redux';
import { selectIsSwedishVisitor } from 'tradera/state/shipping-region/selectors';
import { selectIsForeignLanguageActivated } from 'tradera/state/language/selectors';
import { selectIsOutsideSweden } from 'tradera/state/member/selectors';

const SignUpLink = ({ clickAction, transparentHeader }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const register = t('siteHeader_register');
    const isForeignVisitor = useSelector(
        (state) =>
            (!selectIsSwedishVisitor(state) ||
                selectIsForeignLanguageActivated(state)) &&
            selectIsOutsideSweden(state)
    );
    const url = isForeignVisitor
        ? toLocalizedUrl('/register/foreign-private')
        : toLocalizedUrl('/register');

    return (
        <a
            href={url}
            className={`btn btn-branded slim-header__sign-up-link slim-header__link-spacing px-lg-1 mr-lg-0 d-flex align-items-center ${
                transparentHeader ? 'font-weight-bold' : ''
            }`}
            aria-label={register}
            title={register}
            onClick={clickAction}
            data-nav-signup
            data-ga-category="Top navigation"
            data-ga-action="Signup"
            data-ga-label="Link - Go to signup">
            <span className="slim-header__link-text slim-header__link-text--user d-inline">
                {register}
            </span>
        </a>
    );
};

export default React.memo(SignUpLink);
